import KogInputTextOutlinedControlled from "@/main/components/shared/inputText/inputTextOutlinedControlled";
import { useFormContext, useWatch } from "react-hook-form";
import { getTranslateByKey } from "@/main/services/utils";
import { QuoteSupplierItemPartResponse } from "@/main/models/response";
import * as S from "../../styles";

interface IPickupDaysInputProps {
	fieldPrefix: string;
	showFieldWithouEdit?: boolean;
	row: QuoteSupplierItemPartResponse;
}

export default function ColumnPickupDays({ fieldPrefix, showFieldWithouEdit, row }: IPickupDaysInputProps) {
	const { control } = useFormContext();

	const watcherNotQuote = useWatch({
		control,
		name: `${fieldPrefix}.notQuote`,
		defaultValue: false,
	});

	if (showFieldWithouEdit) {
		return Number(row.pickupTime) > 0 ? <S.TextAlignTable>{row.pickupTime}</S.TextAlignTable> : <></>;
	}

	return (
		<KogInputTextOutlinedControlled
			id="id-createAnswer-txt-pickupTime"
			hasOnlyNumberInteger
			disabledMessage
			name={`${fieldPrefix}.pickupTime`}
			placeholder={getTranslateByKey("information.pickupDaysDeadline")}
			label=""
			control={control}
			hideValue={watcherNotQuote}
			disabled={watcherNotQuote}
			inputProps={{ maxLength: 3 }}
			controllerProps={{
				rules: {
					required: !watcherNotQuote,
					maxLength: 3,
					validate: (value) => watcherNotQuote || value > 0,
				},
			}}
		/>
	);
}
